import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    formLabelClasses,
    Theme,
    stackClasses,
} from '@mui/material';

export const MuiFormLabel: {
    defaultProps?: ComponentsProps['MuiFormLabel'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormLabel'];
    variants?: ComponentsVariants['MuiFormLabel'];
} = {
    styleOverrides: {
        root: (props) => ({
            ...props.theme.typography.label,
            color: props.theme.palette.text.primary,
            paddingBottom: props.theme.spacing(props.theme.tokens.spacing.xs),
            [`&.${formLabelClasses.disabled}`]: {
                color: props.theme.palette.text.primary,
            },
            [`&.${formLabelClasses.focused}`]: {
                color: props.theme.palette.text.primary,
            },
            [`&.${formLabelClasses.error}`]: {
                color: props.theme.palette.error.main,
            },
        }),
        asterisk: (props) => ({
            color: props.theme.palette.error.main,
        }),
    },
};

export const MuiFormControlLabel: {
    defaultProps?: ComponentsProps['MuiFormControlLabel'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiFormControlLabel'];
    variants?: ComponentsVariants['MuiFormControlLabel'];
} = {
    styleOverrides: {
        root: (props) => ({
            marginLeft: 0,
            marginRight: 0,
            alignItems: 'start',
            gap: props.theme.spacing(props.theme.tokens.spacing.xs),
            // Workaround for required. There wasn't a built in way to add styles to the stack
            // that surrounds the asterix and label.
            [`> .${stackClasses.root}`]: {
                marginTop: '.25rem',
            },
        }),
        label: () => ({ marginTop: '.25rem' }),
        asterisk: (props) => ({
            color: props.theme.palette.error.main,
        }),
    },
};
